import apiClient from "./axios"

// Base endpoint
const API_URL = "/transmissions"

// Fetch list of transmissions
export const getTransmissions = async (params = {}) => {
  const response = await apiClient.get(API_URL, { params })
  return response.data
}

// Fetch single transmission by ID
export const getTransmission = async id => {
  const response = await apiClient.get(`${API_URL}/${id}`)
  return response.data
}

// Create a new transmission
export const createTransmission = async payload => {
  const response = await apiClient.post(API_URL, payload)
  return response.data
}

// Edit an existing transmission
export const editTransmission = async ({ id, ...payload }) => {
  const response = await apiClient.put(`${API_URL}/${id}`, payload)
  return response.data
}

// Delete a transmission
export const deleteTransmission = async id => {
  const response = await apiClient.delete(`${API_URL}/${id}`)
  return response.data
}
